import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { openCreateOKRPanel } from 'reducers/createObjectivePanelSlice';
import { useOKRInsights } from 'reducers/okrsPageSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { AgGridAddNewGoalObjectiveSplitButton } from 'screens/Team/Rabbit/Goals/AgGridAddNewGoalObjectiveSplitButton';
import { useOKRManageViewType } from 'screens/Team/Rabbit/Goals/AgGridTreeView/hooks/useOKRManageViewType';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';
import { sendCreatedKREvent, sendCreatedObjectiveEvent } from 'constants/mixpanelHelper';

import { AgGridSearch } from 'uiToolkitV1/AgGridWrapperV2';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gridRef: any;
  refetchCascadedViewData: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedTimelines: any;
  page?: string;
  showAddButton?: boolean;
}

const GoalsIntentAgGridMenu = ({
  gridRef,
  page,
  refetchCascadedViewData,
  selectedTimelines,
  showAddButton = true,
}: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const sideNavSelectedCohort = useSelectedView();
  const { viewType: OKRManageView } = useOKRManageViewType();
  const { viewType: selectedGroupBy } = useOKRInsights();

  const showSearch = OKRManageView === 'list' || OKRManageView === 'listWithHierarchy';

  return (
    <Box mb="12px">
      {/*  @ts-expect-error : union too complex */}
      <Flex
        w="100%"
        sx={{
          span: {
            marginLeft: isMobileView() ? 0 : 'auto',
          },
        }}
        alignItems="center"
        // justifyContent="flex-end"
        marginLeft={isMobileView() ? '10px' : '0px'}
        // mr={isMobileView ? 0 : '16px'}
      >
        {showSearch && (
          <Box w="620px" mr="auto">
            <AgGridSearch
              gridRef={gridRef}
              placeholder="Search across title, owner, progress etc."
              // this is an old component which was made to reset its state when cohortId changes,
              // when user changes group by or view type, the search text should also be cleared
              cohortId={String(sideNavSelectedCohort?.id) + String(OKRManageView) + String(selectedGroupBy)}
              //   @ts-expect-error css?
              inputProps={{ minWidth: '100px' }}
            />
          </Box>
        )}
        {showAddButton && (
          <Box ml="auto">
            <AgGridAddNewGoalObjectiveSplitButton
              onAddKRClick={() => {
                dispatch(
                  // @ts-expect-error error pro max
                  openCreateOKRPanel({
                    selectedObjective: null,
                    selectedTimeBoundPeriod: selectedTimelines?.[0],
                    okrPanelType: OKR_TYPES.KEY_RESULT,
                    onKeyResultCreation(okrDetails) {
                      sendCreatedKREvent({
                        eventProperties: {
                          source: 'Add New Button',
                          page,
                          goalId: okrDetails?.uuid,
                        },
                      });
                      refetchCascadedViewData();
                    },
                    onObjectiveCreation(okrDetails) {
                      sendCreatedObjectiveEvent({
                        eventProperties: {
                          source: 'Add New Button',
                          page,
                          objectiveId: okrDetails?.uuid,
                          description: okrDetails?.description,
                          level: okrDetails?.objectiveLevel,
                          type: okrDetails?.type,
                          timePeriod: okrDetails?.timeBoundDetails?.timelineTag,
                        },
                      });
                      refetchCascadedViewData();
                    },
                    history,
                    location,
                  })
                );
              }}
              onAddObjectiveClick={() => {
                dispatch(
                  // @ts-expect-error error pro max v2
                  openCreateOKRPanel({
                    selectedObjective: null,
                    selectedTimeBoundPeriod: selectedTimelines?.[0],
                    okrPanelType: OKR_TYPES.OBJECTIVE,
                    onKeyResultCreation(okrDetails) {
                      sendCreatedKREvent({
                        eventProperties: {
                          source: 'Add New Button',
                          page,
                          goalId: okrDetails?.uuid,
                        },
                      });
                      refetchCascadedViewData();
                    },
                    onObjectiveCreation(okrDetails) {
                      sendCreatedObjectiveEvent({
                        eventProperties: {
                          source: 'Add New Button',
                          page,
                          objectiveId: okrDetails?.uuid,
                          description: okrDetails?.description,
                          level: okrDetails?.objectiveLevel,
                          type: okrDetails?.type,
                          timePeriod: okrDetails?.timeBoundDetails?.timelineTag,
                        },
                      });
                      refetchCascadedViewData();
                    },
                    history,
                    location,
                  })
                );
              }}
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export { GoalsIntentAgGridMenu };
